module.exports = __webpack_public_path__ + "img/illu-step5-brain.8e18789b.svg";